import React, { useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import pick from 'lodash/pick';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { withContent } from 'components/Content';
import NonDeliveryOption from './NonDeliveryOption';

import styles from './nonDeliveryOptions.scss';

const CONTENT_KEYS = {
  title: 'Title',
  subtitle: 'Subtitle',
  options: 'Features',
};

const StyledAccordionSummary = withStyles((theme) => ({
  root: {
    color: theme.colors.primaryBlue,
    backgroundColor: theme.colors.white,
    height: '6.5625rem',
    border: `1px solid ${theme.colors.primaryBlue}`,
    fontWeight: 600,
  },
  expanded: {
    color: theme.colors.white,
    backgroundColor: theme.colors.primaryBlue,
    margin: 0,
    '& .Mui-expanded': {
      color: theme.colors.white,
    },
  },
  content: {
    margin: 0,
    fontSize: '1.5rem',
  },
  expandIcon: {
    padding: 0,
    margin: 0,
    color: theme.colors.primaryBlue,
    '& svg': {
      fontSize: '3.25rem',
    },
  },
}))(AccordionSummary);

const StyledAccordionDetails = withStyles(() => ({
  root: {
    padding: 0,
  },
}))(AccordionDetails);

const StyledAccordion = withStyles(() => ({
  expanded: {
    marginBottom: `0 !important`,
  },
}))(Accordion);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

const NonDeliveryOptions = ({ content }) => {
  const { title, subtitle, options } = content;
  const [value, setValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleAccordionChange = (accordionValue) => (event, isExpanded) => {
    setValue(isExpanded ? accordionValue : undefined);
  };

  return (
    <section className={styles.nonDeliveryOptions}>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.subtitle}>{subtitle}</p>

      <div className={styles.tabsWrapper}>
        <Tabs
          className={styles.tabs}
          value={value}
          onChange={handleTabChange}
          classes={pick(styles, 'flexContainer', 'indicator')}
        >
          {options.fields.features.map((feature, index) => (
            <Tab
              disableRipple
              className={styles.tab}
              key={feature.sys.id}
              value={index}
              label={get(feature, 'fields.carouselButton.fields.text')}
              classes={pick(styles, 'selected')}
              aria-controls={`tab-panel-${feature.sys.id}`}
              id={`tab-${feature.sys.id}`}
            />
          ))}
        </Tabs>
        {options.fields.features.map((feature, index) => (
          <TabPanel
            key={feature.sys.id}
            value={value}
            index={index}
            id={`tab-panel-${feature.sys.id}`}
            aria-labelledby={`tab-${feature.sys.id}`}
          >
            <NonDeliveryOption option={feature.fields} />
          </TabPanel>
        ))}
      </div>

      <div className={styles.accordionWrapper}>
        {options.fields.features.map((feature, index) => (
          <StyledAccordion
            key={feature.sys.id}
            expanded={value === index}
            onChange={handleAccordionChange(index)}
          >
            <StyledAccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
            >
              {get(feature, 'fields.carouselButton.fields.text')}
            </StyledAccordionSummary>
            <StyledAccordionDetails>
              <NonDeliveryOption option={feature.fields} />
            </StyledAccordionDetails>
          </StyledAccordion>
        ))}
      </div>
    </section>
  );
};

NonDeliveryOptions.propTypes = {
  content: PropTypes.object.isRequired,
};

export default withContent(CONTENT_KEYS)(NonDeliveryOptions);
